"use strict";

var _defineProperty = require("/Users/patrickwitmer/Documents/web/millspublifyer/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/Users/patrickwitmer/Documents/web/millspublifyer/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.onExit = void 0;

var onExit = function onExit(_ref) {
  var node = _ref.node,
      inTransition = _ref.inTransition,
      exitTrigger = _ref.exitTrigger,
      entryProps = _ref.entryProps,
      exitProps = _ref.exitProps,
      triggerResolve = _ref.triggerResolve,
      e = _ref.e;
  if (!inTransition) return;

  var removed = exitProps.trigger,
      exitPropsTrimmed = _objectWithoutProperties(exitProps, ["trigger"]);

  triggerResolve.exit(_objectSpread(_objectSpread({}, exitPropsTrimmed), {}, {
    node: node
  }));
  return exitTrigger && typeof exitTrigger === 'function' && exitTrigger({
    entry: entryProps,
    exit: exitProps,
    node: node,
    e: e
  });
};

exports.onExit = onExit;